import { environment } from '../environments/environment';
import { IProviderAuthConfig } from '@scientificnet/cockpit-core';

// protectedHosts are where the token is added to the http request thanks interceptors
// Note: params like: domain and username are not set by protectedHosts but adding impersonationHosts prop in env
// impersonationHosts: {anyKey: 'domain...', anyKey2: 'other domain...'}
const protectedHosts = new Map<string, string[] | null>();
protectedHosts.set(environment.webservices.cockpitMobile.host, [
  'https://scientificnet.onmicrosoft.com/CockpitMobileTest/user_impersonation',
]);
protectedHosts.set(environment.webservices.centralpoint.host, [
  'https://scientificnet.onmicrosoft.com/Unibz_CPOS_ArchiflowWAPI/user_impersonation',
]);
protectedHosts.set(environment.webservices.ineproApi.host, [
  'https://scientificnet.onmicrosoft.com/CockpitMobileTest/user_impersonation',
]);
protectedHosts.set(environment.webservices.microsoftGraph.host, [
  'https://graph.microsoft.com/user.read',
]);
protectedHosts.set(environment.webservices.dynamicsEuracHr.host, [
  'https://scientificnet.onmicrosoft.com/CockpitMobileTest/user_impersonation',
]);
protectedHosts.set(environment.webservices.snsGraphApi.host, [
  'https://scientificnet.onmicrosoft.com/ScientificNetworkGraphApi/User.Read',
  'https://scientificnet.onmicrosoft.com/ScientificNetworkGraphApi/Person.Read',
]);
protectedHosts.set(environment.webservices.notificationsApi.host, [
  'https://scientificnet.onmicrosoft.com/Notifications.API/Notification.Read',
]);

export const providersConfig: IProviderAuthConfig = {
  microsoftMsalConfig: {
    instanceConfig: {
      auth: {
        clientId: (environment.authConfig as any).clientId,
        // redirectUri: redirectUrl,
      },
    },
    interceptorConfig: {
      protectedResourceMap: protectedHosts,
    },
  },
};

// LOG_LEVEL
// Error = 0,
// Warning = 1,
// Info = 2,
// Verbose = 3,
// Trace = 4,
// All = 5
